import { ChangeDetectionStrategy, Component, input, numberAttribute } from '@angular/core';
import { FastSvgComponent } from '@push-based/ngx-fast-svg';

@Component({
  selector: 'lib-battery',
  standalone: true,
  imports: [FastSvgComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (level() > 50) {
      <fast-svg name="batteryHigh" size="100%" class="text-green-500" />
    } @else if (level() > 30) {
      <fast-svg name="batteryMedium" size="100%" class="text-yellow-300" />
    } @else if (level() !== 0) {
      <fast-svg name="batteryLow" size="100%" class="text-red-500" />
    } @else {
      <fast-svg name="batteryLow" size="100%" class="text-gray-300" />
    }
  `,
  host: {
    class: 'block',
  },
})
export class BatteryComponent {
  level = input.required({ transform: numberAttribute });
}
